import { render, staticRenderFns } from "./ads_detail.vue?vue&type=template&id=2f8c8132"
import script from "./ads_detail.vue?vue&type=script&lang=js"
export * from "./ads_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports